import React from 'react'
import Table, { Cell, Header, Row } from 'components/Table'
import { Input } from 'components/Form'
import { AddIcon, MinusIcon } from 'pages/admin/Preorder/ui/icon'
import '../style.scss'

const toFixed2 = (n) => Number(n || 0).toFixed(2)
const toNum = (v) => Number(v || 0)

const RedeliveryTable = ({
  items,
  onQuantityChange,
  onQuantityInputChange,
}) => {
  return (
    <div className="scrollable-table">
      <Table>
        <Header>
          <Cell>Name</Cell>
          <Cell>SKU</Cell>
          <Cell>Original Quantity</Cell>
          <Cell>Final Quantity</Cell>
          <Cell className="text-right">Original Amount</Cell>
          <Cell className="text-right">Discounted Amount</Cell>
          <Cell>
            <div style={{ textAlign: 'center' }}>Quantity</div>
          </Cell>
          <Cell className="text-right">Amount</Cell>
        </Header>

        {items.map((item, index) => {
          const ordered = toNum(
            item.orderedQuantity ?? item.orderDetails?.orderedQuantity
          )
          const dropped = toNum(
            item.droppedOffQuantity ??
              item.orderDetails?.droppedOffQuantity ??
              item.deliveredQuantity ??
              item.orderDetails?.deliveredQuantity
          )

          const available =
            item._availableForRedelivery ?? Math.max(0, ordered - dropped)
          const currentQty = toNum(item.redeliveryQty ?? 0)

          const isMinusDisabled = currentQty <= 0
          const isAddDisabled = currentQty >= available
          const unit = toNum(item.mrp) - toNum(item.discount)
          const quantityAmount = currentQty * unit

          return (
            <Row key={item.orderItemId}>
              <Cell>{item.name}</Cell>
              <Cell>{item.clientItemId}</Cell>
              <Cell>{ordered}</Cell>
              <Cell>{dropped}</Cell>
              <Cell className="text-right">{`$${toFixed2(item.mrp)}`}</Cell>
              <Cell className="text-right">{`$${toFixed2(unit)}`}</Cell>
              <Cell>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <MinusIcon
                    data-testid="minus-icon"
                    disabled={isMinusDisabled}
                    onClick={() => onQuantityChange(index, -1)}
                    className={`quantity-control-icon minus-icon ${isMinusDisabled ? 'disabled' : ''}`}
                  />
                  <div style={{ width: 40, textAlignLast: 'center' }}>
                    <Input
                      testid="quantity-input"
                      value={
                        item.redeliveryQty === ''
                          ? ''
                          : String(item.redeliveryQty ?? '')
                      }
                      type="number"
                      min={0}
                      max={available}
                      onChange={(e) => onQuantityInputChange(e, index)}
                    />
                  </div>
                  <AddIcon
                    data-testid="add-icon"
                    disabled={isAddDisabled}
                    onClick={() => onQuantityChange(index, +1)}
                    className={`quantity-control-icon add-icon ${isAddDisabled ? 'disabled' : ''}`}
                  />
                </div>
              </Cell>
              <Cell>
                <Input
                  placeholder="price"
                  value={`$${toFixed2(quantityAmount)}`}
                  readOnly
                />
              </Cell>
            </Row>
          )
        })}
      </Table>
    </div>
  )
}

export default RedeliveryTable
